import { Icon, Text } from '@kanda-libs/ks-design-library';
import type { FunctionComponent } from 'react';
import { isBlackFriday } from 'utils';
import type { SubscriptionCardVariant } from './types';

export interface Feature {
  text: string;
  className?: string;
}

export interface FeaturesProps {
  features: Feature[];
  variant?: SubscriptionCardVariant;
  isLoading?: boolean;
}

const Features: FunctionComponent<FeaturesProps> = ({
  features,
  variant = 'standard',
  isLoading = false,
}) => {
  const allFeatures = isLoading
    ? [{ text: 'f1' }, { text: 'f2' }, { text: 'f3' }]
    : features;

  const textColor =
    isBlackFriday() && variant === 'highlight'
      ? 'text-purple-400'
      : 'text-neutral-700';

  return (
    <div className="flex flex-col">
      {allFeatures.map((feature: Feature) => (
        <div className="flex flex-row mt-3 first:mt-0" key={feature.text}>
          <div className="flex w-5 h-5 min-w-5 min-h-5 md:w-6 md:h-6 md:min-w-6 md:min-h-6 rounded-full bg-purple-100 mr-3 md:mr-4 mb-auto">
            <Icon
              icon="check"
              size={12}
              stroke="purple-500"
              className="m-auto"
            />
          </div>
          <Text
            isLoading={isLoading}
            text={feature.text}
            className={`text-14-22 md:text-16-24 ${textColor} my-auto ${
              feature.className || ''
            }`}
            skeletonProps={{
              width: 200,
            }}
          />
        </div>
      ))}
    </div>
  );
};
export default Features;
